<template>
    <div class="container">
        <van-tabs class="tab-wrap" v-model="active" sticky @click="onTabChange" >
            <van-tab v-for="(item , i) in tabData" :title="item.name" :name="item.id" :key="'tab' + i">
                <div class="three-item">
                    <div class="item" v-for="(item, i) in tabContentData" :key="'item' + i"
                         @click="goUrl(item.hrefUrl)">
                        <img class="item-logo" :src="item.logoImg" :alt="item.logoImg"/>
                        <div class="item-title">{{item.name}}</div>
                        <div class="item-price"><span class="icon">¥</span><span
                                class="price">{{item.price}}</span><span class="button">立即抢</span></div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
        <!--  底部  -->
        <Footer></Footer>
    </div>
</template>
<script>
    import {Progress, Tab, Tabs, Toast,Divider,Button} from "vant";
    import {post} from '@/api';
    import {encrypt} from '@/utils/crypto';
    import Footer from "@/pages/Footer";

    export default {
        data() {
            return {
                active: 0,
                showType: 1,
                tabData: [
                    {
                        id: 0,
                        name: '全部',
                    },
                ],
                tabContentData: [],
                imageContentData: []
            };
        },
        created() {
            this.id = this.$route.query.id
            const timestamp = new Date().getTime() + ''
            if (this.id) {
                post('/WebSiteApi/selectWebsiteBodys', {
                    id: this.id,
                    timestamp: timestamp,
                    signature: encrypt(timestamp)
                }).then((res) => {
                    console.log(res);
                    if (res) {
                        this.tabData = this.tabData.concat(res.data.websiteMenus);
                        this.websiteContents = res.data.websiteContents;
                        this.tabContentData = res.data.websiteContents;
                    }
                })
            } else {
                Toast.fail('页面异常')
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Toast.name]: Toast,
            [Progress.name]: Progress,
            [Divider.name]:Divider,
            [Button.name]:Button,
            Footer
        },
        methods: {
            goUrl(url) {
                window.location.href = url;
            },
            onTabChange(id, title) {
                console.log(id, title)
                const websiteContents = this.websiteContents;
                let itemArray = []
                if (id === 0) {
                    this.tabContentData = websiteContents
                } else {
                    itemArray = websiteContents.filter(item => item.websiteMenuId === id).map(item => {
                        return item
                    });
                    this.tabContentData = itemArray
                }
            },
            toPush() {
            },
        },
    };
</script>

<style lang="scss" scoped>
    .container {
        height: 100vh;
        .tab-wrap{
            width: 100%;
            min-height: calc(100vh - 122px);
        }
        .three-item {
            display: grid;
            grid-template-columns: 31% 31% 31%;
            grid-gap: 1% 2%;
            justify-content: center;
            padding-top: 10px;
            /* margin-bottom: 10px; */
            height: 100%;
            .item {
                text-align: center;
                background: #ffffff;
                font-size: 0;
                border: 1px solid #dcdcdc;
                .item-logo {
                    margin-top: 20px;
                    width: 52px;
                    height: 52px;
                }

                .item-title {
                    margin-top: 6px;
                    font-size: 13px;
                    width: 100%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }

                .item-price {
                    margin: 8px 0 12px;
                    font-size: 14px;

                    .icon {
                        font-size: 16px;
                        margin-right: 5px;
                        vertical-align: middle;
                    }

                    .price {
                        font-size: 25px;
                        color: #D9001b;
                        vertical-align: middle;
                        font-weight: bold;
                        display: inline-block;
                        width: 30px;
                        overflow: hidden;
                        white-space: nowrap;
                    }

                    .button {
                        padding: 2px;
                        border-radius: 5px;
                        margin-left: 10px;
                        vertical-align: middle;
                        background-color: #D9001b;
                        color: #ffffff;
                    }

                    @media screen and (max-width: 330px) {
                        .button {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        /deep/.van-sticky{
            border-bottom: 1px solid #dcdcdc;
        }
        .el-login-footer{
            margin-top: 50px
        }
    }
</style>
